import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyBoxComponent } from './empty-box/empty-box.component';
import { BeneficiariesEmptyBoxComponent } from './beneficiaries-empty-box/beneficiaries-empty-box.component';
import { RegulationsEmptyBoxComponent } from './regulations-empty-box/regulations-empty-box.component';

@NgModule({
  declarations: [
    EmptyBoxComponent,
    BeneficiariesEmptyBoxComponent,
    RegulationsEmptyBoxComponent,
  ],
  imports: [CommonModule],
  exports: [
    EmptyBoxComponent,
    BeneficiariesEmptyBoxComponent,
    RegulationsEmptyBoxComponent,
  ],
})
export class EmptyModule {}
